import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Auto-recover from stale bundle / failed dynamic chunk imports after a redeploy.
// Symptoms: "Importing a module script failed", "Failed to fetch dynamically imported module",
// or generic "Load failed" on lazy-loaded routes. We reload once (guarded by sessionStorage) to
// pull the fresh bundle instead of leaving the user stuck on a broken page.
const isChunkLoadError = (msg: string | undefined) => {
  if (!msg) return false;
  return (
    msg.includes("Importing a module script failed") ||
    msg.includes("Failed to fetch dynamically imported module") ||
    msg.includes("error loading dynamically imported module") ||
    msg.includes("Load failed")
  );
};

const tryReloadOnce = () => {
  const key = "lovable:chunk-reload";
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, String(Date.now()));
  window.location.reload();
};

window.addEventListener("error", (event) => {
  if (isChunkLoadError(event.message)) tryReloadOnce();
});

window.addEventListener("unhandledrejection", (event) => {
  const reason: any = event.reason;
  const msg = typeof reason === "string" ? reason : reason?.message;
  if (isChunkLoadError(msg)) tryReloadOnce();
});

// Clear the reload guard once the app boots successfully so future stale bundles can recover.
window.addEventListener("load", () => {
  setTimeout(() => sessionStorage.removeItem("lovable:chunk-reload"), 5000);
});

createRoot(document.getElementById("root")!).render(<App />);
